import { Component } from '@angular/core';

@Component({
  selector: 'app-lite-flow-event',
  imports: [],
  templateUrl: './lite-flow-event.html',
  styleUrl: './lite-flow-event.css',
})
export class LiteFlowEvent {}
